import { render, staticRenderFns } from "./ModalInOrdersDetail.vue?vue&type=template&id=942ece96&lang=pug&"
import script from "./ModalInOrdersDetail.vue?vue&type=script&lang=js&"
export * from "./ModalInOrdersDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalInOrdersDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports